module.exports = require('./lib/websocket');


//////////////////
// WEBPACK FOOTER
// ./~/web3-shh/~/websocket/index.js
// module id = 1963
// module chunks = 0 1 3